import generalSection from "../_section/section.class";
import {userMarriageCertificateUpload, adminMarriageCertificateUpload} from "./upload";

export class userMarriageCertificateSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userMarriageCertificateUpload);
        // Add missing date error

    }
}

export class adminMarriageCertificateSection extends userMarriageCertificateSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminMarriageCertificateUpload);
        //this.DataForm = DataForm
        this.sortByDateProp('documentDate');
        this.activeUpload = this.uploads.find(u=> u.allValuesAnswered && u.isVerifiable)
        this.setProblems(this.problemsList.singleUploadUserProblems())
    }

    // get documentDate() {
    //     if (this.activeUpload && this.activeUpload.values.documentDate) {
    //         return this.activeUpload.values.documentDate;
    //     }
    //     return null;
    // }
}